import { Modal, Button, Alert } from 'react-bootstrap';
import type { Ingredient } from '../../../../models/Ingredient';

interface DeleteIngredientModalProps {
  readonly show: boolean;
  readonly ingredient: Ingredient | null;
  readonly onHide: () => void;
  readonly onConfirm: () => void;
  readonly isDeleting: boolean;
}

export const DeleteIngredientModal = ({
  show,
  ingredient,
  onHide,
  onConfirm,
  isDeleting,
}: DeleteIngredientModalProps) => {
  if (!ingredient) {
    return null;
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Ingredient</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="danger">
          <Alert.Heading>Warning!</Alert.Heading>
          <p>
            Are you sure you want to delete the ingredient <strong>"{ingredient.ingredientName}"</strong>?
          </p>
          <p className="mb-0">
            This action will permanently delete <strong>ALL VERSIONS</strong> of this ingredient and cannot be undone.
          </p>
        </Alert>

        <div className="mt-3">
          <h6>Ingredient Details:</h6>
          <ul className="list-unstyled">
            <li>
              <strong>Name:</strong> {ingredient.ingredientName}
            </li>
            <li>
              <strong>English Name:</strong> {ingredient.engName}
            </li>
            <li>
              <strong>Korean Name:</strong> {ingredient.korName}
            </li>
            <li>
              <strong>Current Version:</strong> {ingredient.version}
            </li>
            <li>
              <strong>Risk Level:</strong> {ingredient.risk}
            </li>
            <li>
              <strong>Last Updated:</strong> {new Date(ingredient.updateAt).toLocaleDateString()}
            </li>
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete All Versions'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
